import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overlay-content controls h-100"
}
const _hoisted_2 = {
  key: 1,
  class: "overlay-content"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content-text" }
const _hoisted_5 = {
  key: 2,
  class: "overlay-content"
}
const _hoisted_6 = { class: "content-timer" }
const _hoisted_7 = { class: "content-text" }
const _hoisted_8 = {
  key: 3,
  class: "overlay-content h-100"
}
const _hoisted_9 = { class: "content-timer ready" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "content-text danger mt-5" }
const _hoisted_12 = {
  key: 5,
  class: "overlay-content h-100"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "content-text danger mt-5" }
const _hoisted_15 = {
  key: 6,
  class: "overlay-content"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "content-text warning mt-5" }
const _hoisted_18 = {
  key: 7,
  class: "overlay-content"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "content-text mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SellBtn = _resolveComponent("SellBtn")!
  const _component_WithdrawBtn = _resolveComponent("WithdrawBtn")!
  const _component_TryAgainBtn = _resolveComponent("TryAgainBtn")!
  const _component_TooltipHover = _resolveComponent("TooltipHover")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["item-overlay", {
			hover: _ctx.hover,
			danger: _ctx.danger,
			completed: _ctx.completed,
			allowClick: _ctx.allowClick
		}]),
    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mouse(true))),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mouse(false)))
  }, [
    (_ctx.status === 'IDLE')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_SellBtn, {
            class: "sell-btn",
            onClick: _ctx.sell
          }, null, 8, ["onClick"]),
          (_ctx.withdrawBtn)
            ? (_openBlock(), _createBlock(_component_WithdrawBtn, {
                key: 0,
                class: "withdraw-btn",
                onClick: _ctx.withdraw
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('InventoryItemOverlay.withdraw')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (['BUYING', 'SELLING'].includes(_ctx.status))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            src: require('../../assets/icons/overlay_process.svg'),
            class: "content-logo"
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.loadingText), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.status === 'WAITING_SELLER')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.timer), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.t('InventoryItemOverlay.waitingSeller')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.status === 'READY')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.timer), 1),
          _createVNode(_component_WithdrawBtn, {
            class: "take-btn",
            onClick: _ctx.offer
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('InventoryItemOverlay.take')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.error && _ctx.status === 'ERROR')
      ? (_openBlock(), _createBlock(_component_TooltipHover, {
          key: 4,
          class: "overlay-content"
        }, {
          text: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.errorNormalized), 1)
          ]),
          root: _withCtx(() => [
            _createElementVNode("img", {
              src: require('../../assets/icons/danger.svg'),
              class: "content-logo error"
            }, null, 8, _hoisted_10),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.t('InventoryItemOverlay.error')), 1),
            _createVNode(_component_SellBtn, {
              class: "try-again-sell-btn",
              onClick: _ctx.sell
            }, null, 8, ["onClick"]),
            (_ctx.withdrawBtn)
              ? (_openBlock(), _createBlock(_component_TryAgainBtn, {
                  key: 0,
                  class: "try-again-btn",
                  onClick: _ctx.withdraw
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.error && _ctx.status === 'ERROR')
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("img", {
            src: require('../../assets/icons/danger.svg'),
            class: "content-logo error"
          }, null, 8, _hoisted_13),
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t('InventoryItemOverlay.error')), 1),
          _createVNode(_component_SellBtn, {
            class: "try-again-sell-btn",
            onClick: _ctx.sell
          }, null, 8, ["onClick"]),
          (_ctx.withdrawBtn)
            ? (_openBlock(), _createBlock(_component_TryAgainBtn, {
                key: 0,
                class: "try-again-btn",
                onClick: _ctx.withdraw
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.status === 'COMPLETED')
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("img", {
            src: require('../../assets/icons/withdraw.svg'),
            class: "content-icon"
          }, null, 8, _hoisted_16),
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.t('InventoryItemOverlay.withdrawn')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.status === 'SOLD')
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("img", {
            src: require('../../assets/icons/overlay_process.svg'),
            class: "content-icon"
          }, null, 8, _hoisted_19),
          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.t('InventoryItemOverlay.sold')), 1)
        ]))
      : _createCommentVNode("", true)
  ], 34))
}